module.exports = __webpack_public_path__ + "static/media/ic-conte-do.40022563.svg";